/** Asset of header.liquid section */


class CartNotification extends HTMLElement
{
    constructor()
    {
        super();

        this.notification = document.getElementById('cart-notification');
        this.header = document.querySelector('sticky-header');
        this.onBodyClick = this.handleBodyClick.bind(this);

        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this)),
        );

        //console.log(document.querySelector('.view_cart_link'))
        //document.querySelector('.view_cart_link').addEventListener('click', this.close.bind(this));
        //this.viewCart.addEventListener('click', this.openCart)
    }

    openCart()
    {
        alert('yes');
    }

    open()
    {
        this.notification.classList.add('animate', 'active');

        this.notification.addEventListener('transitionend', () => {
            this.notification.focus();
            trapFocus(this.notification);
        }, {once: true});

        document.body.addEventListener('click', this.onBodyClick);

        //console.log(document.querySelector('.view_cart_link'))
    }

    close()
    {
        this.notification.classList.remove('active');

        document.body.removeEventListener('click', this.onBodyClick);

        removeTrapFocus(this.activeElement);
    }

    /**
     * Hydrate sections with the response of the submitted Add To Cart form
     * @param {Object} parsed_state Response of the fetch()
     */
    renderContents(parsed_state)
    {
        this.productId = parsed_state.id;

        this.getSectionsToRender().forEach((section => {
          if(section.selector === "#productForm"){
              const elementToReplace = document.getElementById("productForm");
              if(elementToReplace === null) {return}
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsed_state.sections[section.section], section.selector);
          }else{
            document.getElementById(section.id).innerHTML =
                this.getSectionInnerHTML(parsed_state.sections[section.id], section.selector);
          }
        }));

        if (this.header) this.header.reveal();

        this.open();
        //document.querySelector('.view_cart_link').addEventListener('click', this.openCart());
    }

    /**
     * List of ids (names of liquid files in sections/) passed to the fetch query in product-form.js
     * In a sections array of the response we get rendered sections with updated data, which can be assessed by id
     * and needed html can be query selected by selector
     *
     * @returns {[{selector: string, id: string}]} It seems that only id and selector is used
     */
    getSectionsToRender()
    {
        return [
            {
                id: 'cart-notification-product',
                selector: `#cart-notification-product-${this.productId}`,
            },
            {
                id: 'cart-icon-bubble',
            },
            {
                id: 'main-cart-items',
                section: 'main-cart-items',
                selector: '.js-contents',
            },
            {
                id: 'main-cart-footer',
                section: 'main-cart-footer',
                selector: '#main-cart-footer',
            },
            {
              id: (document.getElementById('productForm') ? document.getElementById('productForm').dataset.id : 'productForm') || 'productForm',
              section: (document.getElementById('productForm') ? document.getElementById('productForm').dataset.id : 'productForm') || 'productForm',
              selector: '#productForm',
            },
        ];
    }

    /**
     * Parse string with html code and return inner html of the selector
     * @param {string} html
     * @param {string} selector
     * @returns {string}
     */
    getSectionInnerHTML(html, selector = '.shopify-section')
    {
        var element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
        return element ? element.innerHTML : ''
    }

    handleBodyClick(evt)
    {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }

    setActiveElement(element)
    {
        this.activeElement = element;
    }
}

customElements.define('cart-notification', CartNotification);
